import React from "react";
import "./cardSpecialist.scss";
import { normalizeTwoWords } from "../../../shared/utils/stringUtilities";
interface CardSpecialistInterface {
  specialist: {
    name: string;
    especialidad?: string;
    desc?: string;
    id?: any;
    avatarUrl?: any;
    service: any;
  };
  active?: boolean;
  setcardActvie?: any;
  selectSpecialitsSearch?: any;
  setselectSpecialitsSearch?: any;
  others?: boolean;
  onAction?: any;
  description: string;
  gtm?: string;
}
const imagenDefault = require("../../../assets/images/not-found/not-found-image.jpg");
const CardSpecialist = (props: CardSpecialistInterface) => {
  const {
    specialist,
    active,
    setcardActvie,
    selectSpecialitsSearch,
    setselectSpecialitsSearch,
    others,
    onAction,
    //description,
    gtm,
  } = props;

  return (
    <div
      className={`a-cardspecialist${active ? " a-cardspecialist--active" : ""}${
        others ? " a-cardspecialist__others" : ""
      }  gtmRedDeAmorSesionIniciadaAgendarServicioEspecialista${normalizeTwoWords(
        gtm
      )}${normalizeTwoWords(specialist.name)} `}
      onClick={() => {
        if (active) {
          setcardActvie("");
          if (selectSpecialitsSearch) setselectSpecialitsSearch("");
        } else {
          setcardActvie(specialist.id);
        }
        onAction && onAction(specialist);
      }}
    >
      {others ? null : (
        <span
          className={`a-cardspecialist__check${
            active ? " a-cardspecialist__check--active" : ""
          }  gtmRedDeAmorSesionIniciadaAgendarServicioEspecialista${normalizeTwoWords(
            gtm
          )}${normalizeTwoWords(specialist.name)}`}
        />
      )}
      {active && <i className="icon icon-check1" />}
      <div
        className={`a-cardspecialist__content  gtmRedDeAmorSesionIniciadaAgendarServicioEspecialista${normalizeTwoWords(
          gtm
        )}${normalizeTwoWords(specialist.name)}`}
      >
        <img
          className={`
            ${
              others
                ? " a-cardspecialist__others__img"
                : "a-cardspecialist__content__img"
            }
          gtmRedDeAmorSesionIniciadaAgendarServicioEspecialista${normalizeTwoWords(
            gtm
          )}${normalizeTwoWords(specialist.name)}`}
          src={specialist.avatarUrl ? specialist.avatarUrl : imagenDefault}
          alt="Avatar"
        />
        <div
          className={`${
            others
              ? " a-cardspecialist__others__info"
              : "a-cardspecialist__content__info"
          }  gtmRedDeAmorSesionIniciadaAgendarServicioEspecialista${normalizeTwoWords(
            gtm
          )}${normalizeTwoWords(specialist.name)}`}
        >
          <h4
            className={` ${
              others
                ? " a-cardspecialist__others__info__name"
                : "a-cardspecialist__content__info__name"
            }  gtmRedDeAmorSesionIniciadaAgendarServicioEspecialista${normalizeTwoWords(
              gtm
            )}${normalizeTwoWords(specialist.name)}`}
          >
            {specialist.name}
          </h4>
          {
            <p
              className={`a-cardspecialist__content__info__specialty  gtmRedDeAmorSesionIniciadaAgendarServicioEspecialista${normalizeTwoWords(
                gtm
              )}${normalizeTwoWords(specialist.name)}`}
            >
              {specialist.service.name}
            </p>
          }
        </div>
      </div>
    </div>
  );
};

export default CardSpecialist;
